import {
  isEmpty,
  type DashboardDataWithEditable,
  type DashboardListInput,
  type DashboardListSuccess,
} from '@terros/common'
import { useTantalimQuery } from '../query'
import { dashboardsKey } from '../keys'
import { type GetHookResponse, type WithEnabled } from '../hooks'

export type UseDashboardsProps = WithEnabled & DashboardListInput

export function useDashboards(input: UseDashboardsProps = {}): GetHookResponse<DashboardDataWithEditable[]> {
  const { enabled, ...listInput } = input
  return useTantalimQuery<DashboardListInput, DashboardListSuccess, DashboardDataWithEditable[]>({
    url: '/report/dashboard/list',
    queryKey: dashboardsKey(isEmpty(listInput) ? undefined : listInput),
    input: listInput,
    convertResponse: (data) => {
      return data.dashboards
    },
    options: {
      enabled,
    },
  })
}
